<template>
    <p-inc-todo-card
        :item = "item"
    >
        <template v-slot:comment>
            <div class="card-subtitle primary--text reason-text">
                {{ reasons }}
            </div>
        </template>
    </p-inc-todo-card>
</template>

<script>

import PIncTodoCard     from "@/modules/inc/todos/components/private/PIncTodoCard.vue";
import IncTodoCardMixin from "@/modules/inc/todos/components/mixins/IncTodoCardMixin";

export default {
    name: "CIncRequiredFieldsCard",

    components: {
        PIncTodoCard
    },

    mixins: [
        IncTodoCardMixin
    ],

    computed: {
        reasons () {
            let result = "";
            const tokens = this.item.reason.split (";");
            tokens.forEach ((token, index, array) => {
                result += this.$t("inc." + token);
                if (index < array.length - 1) {
                    result += ", ";
                }
            });

            return result;
        }
    }
}
</script>

<style scoped>

.reason-text {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: calc(100% - 1px);
}

.card-subtitle {
    font-size: 13px;
}

</style>
